export default {
    notFound: 'not_found',
    redirectPermanent: 'redirect_permanent',
    category: 'category',
    product: 'product',
};
